module.exports = __webpack_public_path__ + "img/pencil.57cd267e.svg";